import {DimensionValue, Pressable, StyleSheet, View} from "react-native";
import {Image} from "expo-image";
import {BASE_URL} from "@/lib/constants";

type Props = {
    thumbnailIds: string[],
    onPressThumbnail?: (thumbnailID: string) => any,
    onLongPress?: () => any,
}

export default function Mosaic({thumbnailIds, onPressThumbnail, onLongPress}: Props) {
    if (thumbnailIds.length === 0) {
        return;
    }

    const numTopRow = thumbnailIds.length % 3;
    const topRowWidth = numTopRow === 0 ? "100%" : `${Math.floor(100 / numTopRow)}%` as DimensionValue;

    return (
        <View style={styles.container}>
            {thumbnailIds.map((id, index) => (
                <Pressable
                    key={id}
                    onPress={() => onPressThumbnail?.(id)}
                    onLongPress={onLongPress}
                    style={[styles.thumbnail, {
                        width: index < numTopRow ? topRowWidth : "33%",
                    }]}
                >
                    <Image source={BASE_URL + `/f/originals/${id}.webp`} style={styles.thumbnailImage}/>
                </Pressable>
            ))}
        </View>
    );
}

export const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%",
        minHeight: 80,
    },
    thumbnail: {
        aspectRatio: 1,
        minWidth: 80,
        flexGrow: 1,
    },
    thumbnailImage: {
        width: "100%",
        height: "100%",
        aspectRatio: 1,
    },
})